import { defineComponent, computed, toRef, openBlock, createElementBlock, toDisplayString, unref } from "vue";
import { useFormatTime, useFormatRelativeTime } from "../composables/useFormatDateTime/index.mjs";
const _hoisted_1 = ["data-timestamp", "title", "textContent"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcDateTime",
  props: {
    timestamp: {},
    format: { default: () => ({ timeStyle: "medium", dateStyle: "short" }) },
    relativeTime: { type: [Boolean, String], default: "long" },
    ignoreSeconds: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const timeOptions = computed(() => ({ format: props.format }));
    const relativeTimeOptions = computed(() => ({
      ignoreSeconds: props.ignoreSeconds,
      relativeTime: props.relativeTime || "long",
      update: props.relativeTime !== false
    }));
    const title = useFormatTime(toRef(() => props.timestamp), timeOptions);
    const relativeTime = useFormatRelativeTime(toRef(() => props.timestamp), relativeTimeOptions);
    const formattedTime = computed(() => props.relativeTime ? relativeTime.value : title.value);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: "nc-datetime",
        dir: "auto",
        "data-timestamp": __props.timestamp,
        title: unref(title),
        textContent: toDisplayString(formattedTime.value)
      }, null, 8, _hoisted_1);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=NcDateTime.vue_vue_type_script_setup_true_lang.mjs.map
